exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".editor-background-image:before{content:\"\";pointer-events:none;position:absolute;top:0px;left:0px;bottom:0px;right:0px;background-size:var(--backgroundSize);background-position:var(--backgroundPosition);background-attachment:var(--backgroundAttachment);background-repeat:var(--backgroundRepeat);background-image:var(--backgroundImage);opacity:var(--opacity)}\n", ""]);

// exports
